// TODO: migrate to dynamic parser element
$(document).on('click', '.user-defined', ({ currentTarget }) => {
  currentTarget.classList.toggle('active');
});
